var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47897 15.5952L5.75097 11.3222C5.33431 11.0384 4.97473 10.6788 4.69097 10.2622L0.417969 14.5332C0.744969 14.9132 1.09897 15.2672 1.47797 15.5932L1.47897 15.5952ZM0.417969 1.49318L4.69097 5.76518C4.97475 5.34854 5.33433 4.98896 5.75097 4.70518L1.47997 0.430176C1.09997 0.757176 0.745969 1.11218 0.418969 1.49118L0.417969 1.49318ZM10.248 4.70418L14.52 0.433176C14.899 0.759176 15.254 1.11318 15.58 1.49318L11.31 5.76518C11.0259 5.34843 10.666 4.98884 10.249 4.70518L10.248 4.70418ZM15.581 14.5342L11.308 10.2612C11.0242 10.6778 10.6646 11.0374 10.248 11.3212L14.52 15.5952C14.9 15.2682 15.255 14.9132 15.581 14.5342Z",
    fill: "#8A92A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.f0e127eed7b703024dd1caabb2c7743c.svg";
export { ForwardRef as ReactComponent };